var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback-buttons" }, [
    _c(
      "div",
      { staticClass: "feedback-buttons__linha d-flex align-center" },
      [
        _c(
          "v-btn",
          {
            attrs: {
              icon: "",
              "x-small": "",
              color: _vm.feedbackState.thumbsUp.color,
              "aria-pressed": String(_vm.feedbackState.thumbsUp.active),
              "aria-label": "Marcar resposta como útil",
              title: "Marcar como útil"
            },
            on: {
              click: function($event) {
                return _vm.giveFeedback("thumbs_up")
              }
            }
          },
          [
            _c("icon-svg", {
              attrs: {
                name: _vm.feedbackState.thumbsUp.icon,
                size: 15,
                color: _vm.feedbackState.thumbsUp.color
              }
            })
          ],
          1
        ),
        _c(
          "v-btn",
          {
            attrs: {
              icon: "",
              "x-small": "",
              color: _vm.feedbackState.thumbsDown.color,
              "aria-pressed": String(_vm.feedbackState.thumbsDown.active),
              "aria-label": "Marcar resposta como não útil",
              title: "Marcar como não útil"
            },
            on: {
              click: function($event) {
                return _vm.giveFeedback("thumbs_down")
              }
            }
          },
          [
            _c("icon-svg", {
              attrs: {
                name: _vm.feedbackState.thumbsDown.icon,
                size: 15,
                color: _vm.feedbackState.thumbsDown.color
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.feedbackEmEdicao
      ? _c(
          "div",
          {
            staticClass: "feedback-buttons__comentario mt-1",
            attrs: { "data-test": "feedback-buttons-comentario" }
          },
          [
            _c("input-by-type", {
              attrs: {
                type: "textarea",
                counter: _vm.comentarioMaxLength,
                maxlength: _vm.comentarioMaxLength,
                placeholder: _vm.feedbackButtonsText.placeholderComentario,
                rows: "2",
                outlined: "",
                dense: "",
                "data-test": "feedback-buttons-textarea"
              },
              model: {
                value: _vm.comentarioRascunho,
                callback: function($$v) {
                  _vm.comentarioRascunho = $$v
                },
                expression: "comentarioRascunho"
              }
            }),
            _c(
              "div",
              {
                staticClass:
                  "feedback-buttons__comentario-rodape d-flex align-center justify-end"
              },
              [
                _c(
                  "div",
                  { staticClass: "feedback-buttons__comentario-acoes d-flex" },
                  [
                    _c(
                      "BaseButton",
                      {
                        attrs: {
                          underlined: "",
                          "fit-content": "",
                          "data-test": "feedback-buttons-cancelar"
                        },
                        on: { click: _vm.fecharComentario }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.feedbackButtonsText.botaoCancelar) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "BaseButton",
                      {
                        attrs: {
                          primary: "",
                          "fit-content": "",
                          "data-test": "feedback-buttons-enviar"
                        },
                        on: { click: _vm.enviarComentario }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.feedbackButtonsText.botaoEnviar) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      : _vm.mostrarComentarioJaDado
      ? _c(
          "div",
          {
            staticClass: "feedback-buttons__comentario-dado ia-texto-auxiliar",
            attrs: {
              title: _vm.currentComentario,
              "data-test": "feedback-buttons-comentario-dado"
            }
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.feedbackButtonsText.comentarioDadoPrefixo) +
                _vm._s(_vm.currentComentario) +
                " "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }